<template>
  <div
    class="br-pop-btn"
    @click.prevent="click"
    :style="{
      backgroundColor: button && button.background_color,
      color: button && button.text_color,
    }"
  >
    
    <span
      class="iconfont icon-cm-xiajiantou-cu"
      :class="{ active_icon: active }"
    ></span>
    <span class="br-btn-name"> {{ title }}</span>
  </div>
</template>
<script>

export default {
  props: ["click", "active", "title", "button", ],
};
</script>
<style scoped lang='scss'>
.br-pop-btn {
  position: absolute;
  padding: 0px 6px;
  border-radius: 8px;
  background-color: #222a40;
  opacity:0.9;
  font-size: 16px;
  color: white;
  //writing-mode: tb-rl;
  transform: rotate(90deg);
  transform-origin: 0 0 ;
  cursor: pointer;
  z-index: 100;
  line-height: 18px;
  text-align: center;

  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  & > .br-btn-name {
    margin-left: 5px;
    backface-visibility: hidden;
    transform: rotate(180deg);
    display: inline-block;
    line-height: 32px;
    font-weight: 600;
    //word-break: keep-all;
    white-space: nowrap;
  }
  & > .icon-cm-xiajiantou-cu {
    //padding: 2px 0px 7px 0px;
    line-height: 32px;
    display: inline-block;
    transform: rotate(0deg);
    //transform-origin: 50% 43%;
    font-size: 16px;
    transition: all 0.5s;
    font-weight: 500;
  }
  // & > .icon-cm-xiajiantou1::before{
  //    content: "\E62A";
  // }
  & > .active_icon {
    transform: rotate(180deg);
  }
}
// @media screen and (max-width: 768px) {
// .br-pop-btn {
// }

// }
</style>